/**
 * O'zbek tili (lotin) — default locale
 *
 * Kanonik strings — har sahifa shu yerdan chaqiradi t('common.save') kabi.
 * Qo'shish qoidalari:
 *   - nested keys ishlatish (common, nav, auth, products, ...)
 *   - interpolatsiya: {{name}}
 *   - plural: _one, _other suffix
 */

export const uz = {
  common: {
    save: 'Saqlash',
    cancel: 'Bekor qilish',
    delete: "O'chirish",
    edit: 'Tahrirlash',
    add: "Qo'shish",
    search: 'Qidirish',
    loading: 'Yuklanmoqda...',
    empty: "Ma'lumot topilmadi",
    error: 'Xato',
    success: 'Muvaffaqiyat',
    confirmDelete: "Rostdan ham o'chirilsinmi?",
    yes: 'Ha',
    no: "Yo'q",
    total: 'Jami',
    page: 'Sahifa',
    previous: 'Oldingi',
    next: 'Keyingi',
    name: 'Nomi',
    phone: 'Telefon',
    email: 'Email',
    status: 'Status',
    actions: 'Amallar',
    currency_uzs: "so'm",
    close: 'Yopish',
  },

  nav: {
    dashboard: 'Dashboard',
    kassa: 'Kassa',
    orderRequests: 'Buyurtmalar',
    specialOrders: 'Yangi buyurtmalar',
    products: 'Mahsulotlar',
    categories: 'Kategoriyalar',
    suppliers: 'Taminotchilar',
    customers: 'Mijozlar',
    debts: 'Qarzlar',
    debtCategories: 'Qarz kategoriyalari',
    stats: 'Statistika',
    roles: 'Rollar va xodimlar',
    users: 'Foydalanuvchilar',
    xodimlar: 'Xodimlar',
    stores: "Do'konlar",
    marketplaceOrders: 'Marketplace',
    pickupPoints: 'Pickup punktlar',
    promoCodes: 'Promokodlar',
    marketplaceBanners: 'Bannerlar',
    pickupOperator: 'Mening punktim',
    courier: 'Yetkazib berish',
    courierTracking: 'Kuryerlar',
    settings: 'Sozlamalar',
    logout: 'Chiqish',
  },

  auth: {
    login: 'Kirish',
    username: 'Login',
    password: 'Parol',
    signIn: 'Kirish',
    welcome: 'Xush kelibsiz',
    loginSubtitle: 'AvtoFix POS tizimiga kiring',
    invalidCredentials: "Login yoki parol noto'g'ri",
    loggingIn: 'Kirilmoqda...',
  },

  products: {
    title: 'Mahsulotlar',
    new: 'Yangi mahsulot',
    searchPlaceholder: "Nom, SKU yoki barcode bo'yicha qidirish...",
    statusAll: 'Hammasi',
    statusAvailable: 'Mavjud',
    statusPending: 'Kutilmoqda',
    statusFinished: 'Tugagan',
    empty: 'Mahsulot topilmadi',
    emptyHint: "Birinchi mahsulotingizni qo'shing",
    deleted: "Mahsulot o'chirildi",
  },

  customers: {
    title: 'Mijozlar',
    new: 'Yangi mijoz',
    searchPlaceholder: "Ism, telefon yoki email bo'yicha qidirish...",
    empty: 'Mijoz topilmadi',
    orderCount: 'Buyurtmalar',
    totalSpent: 'Jami',
    vip: 'VIP',
    created: "Mijoz qo'shildi",
    updated: 'Mijoz yangilandi',
    deleted: "Mijoz o'chirildi",
  },

  debts: {
    title: 'Qarzlar',
    statusPending: 'Kutilmoqda',
    statusPaid: "To'langan",
    statusOverdue: "Muddati o'tgan",
    statusBlacklist: "Qora ro'yxat",
    amount: 'Qarz',
    paid: "To'langan",
    remaining: 'Qoldiq',
    pay: "To'lov",
    payAmountPrompt: "To'lov miqdori (qoldiq: {{remaining}} so'm):",
    invalidAmount: "Noto'g'ri miqdor",
    paidFully: "Qarz to'liq to'landi",
    paidPartial: "Qisman to'lov qabul qilindi",
    blacklistConfirm: "Mijozni qora ro'yxatga olish?",
    blacklisted: "Qora ro'yxatga olindi",
    empty: 'Qarz topilmadi',
  },

  stats: {
    title: 'Statistika',
    subtitle: 'Daromad, top mahsulotlar, qarzlar — real-time',
    periodToday: 'Bugun',
    periodWeek: 'Oxirgi 7 kun',
    periodMonth: 'Oxirgi 30 kun',
    revenue: 'Daromad',
    profit: 'Foyda',
    orders: 'Buyurtmalar',
    customers: 'Mijozlar',
    cash: 'Naqd',
    card: 'Karta',
    transfer: "O'tkazma",
    topProducts: 'Top sotilgan mahsulotlar',
    noSales: "Sotuv bo'lmagan",
    debtsTitle: 'Qarzlar',
    totalDebt: 'Jami qarz',
    outstanding: 'Qoldiq',
    lowStock: 'Stok kam',
    lowStockHint: '{{count}} ta mahsulot minimumdan past',
  },

  users: {
    title: 'Xodimlar',
    new: 'Yangi xodim',
    username: 'Login',
    role: 'Rol',
    active: 'Faol',
    empty: "Xodim yo'q",
    blocked: 'Bloklandi',
    activated: 'Faollashtirildi',
  },

  stores: {
    title: "Do'konlar",
    new: "Yangi do'kon",
    mainStore: "Asosiy do'kon",
    setAsMain: "Asosiy do'kon qilib belgilash",
    address: 'Manzil',
    empty: "Do'kon yo'q",
    usdRate: 'USD kurs',
    markup: 'Markup',
    brand: 'Brand',
  },

  offline: {
    online: 'Onlayn',
    offline: 'Oflayn',
    syncing: 'Sinxronlashmoqda...',
    pending: 'Kutilayotgan: {{count}}',
    dlq: 'Xato: {{count}}',
  },
};

/**
 * Translations — `uz` ning strukturasi, lekin qiymatlar umumiy `string`.
 * Bu boshqa tillar (uzCyrl, ru) bir xil kalitlarga ega bo'lishini kafolatlaydi,
 * lekin ularning qiymatlari literal uz stringlari bilan chegaralanmaydi.
 */
type DeepStringify<T> = T extends string
  ? string
  : T extends object
    ? { [K in keyof T]: DeepStringify<T[K]> }
    : T;

export type Translations = DeepStringify<typeof uz>;
